import { formatToCNPJ, formatToCPF } from 'brazilian-values';

import { getObscuredTaxIDType, TAXID_TYPE } from '@woovi/shared';

import { obscureCNPJ } from './obscureCNPJ.ts';
import { obscureCPF } from './obscureCPF.ts';

export const obscureTaxID = (taxID: string) => {
  const type = getObscuredTaxIDType(taxID);

  if (type === TAXID_TYPE.BR_CPF) {
    return obscureCPF(formatToCPF(taxID));
  }

  if (type === TAXID_TYPE.BR_CNPJ) {
    return obscureCNPJ(formatToCNPJ(taxID));
  }

  return taxID;
};
